import useThemeStore from '../../store/themeStore';
import { Sun, Moon } from 'lucide-react';

export default function ThemeToggle({ className = '' }) {
    const { theme, toggleTheme } = useThemeStore();

    return (
        <button
            className={`theme-toggle ${className}`}
            onClick={toggleTheme}
            title={theme === 'dark' ? 'Mode clair' : 'Mode sombre'}
            aria-label={theme === 'dark' ? 'Mode clair' : 'Mode sombre'}
        >
            {theme === 'dark' ? (
                <Sun size={18} strokeWidth={1.8} />
            ) : (
                <Moon size={18} strokeWidth={1.8} />
            )}
        </button>
    );
}
